import ctrlRegFn from './confirmationController';
import template from './confirmationDialog.html';

function confirmationDialog($uibModal) {
  const service = {};

  service.confirm = (
    messageToken,
    successCallback,
    errorCallback = angular.noop
  ) => {
    $uibModal
      .open({
        template,
        controller: 'DeleteConfirmationController',
        size: 'sm',
        resolve: {
          message() {
            return messageToken;
          }
        }
      })
      .result.then(successCallback, errorCallback);
  };

  return service;
}

const confirmationDialogArray = ['$uibModal', confirmationDialog];

export default (ngModule) => {
  ngModule.factory('confirmationDialog', confirmationDialogArray);
  ctrlRegFn(ngModule);
};
